import { PageWrapper } from '@src/components';
import { Simcard1 } from 'iconsax-react';
// import { ReactComponent as InstallationGuideImage } from '@src/assets/images/InstallationGuide.svg';
import { ResponsiveModal } from '@src/components/ResponsiveModal';
import { useState } from 'react';
import { AppleGuide, ChooseDevice, InstallationGuideImage } from './components';
import { AndroidGuide } from './components/AndroidGuide';
import clsx from 'clsx';

type InstallationGuideProps = {
  className?: string;
};

export function InstallationGuide({ className }: InstallationGuideProps) {
  const [chooseDevice, setChooseDevice] = useState(false);
  const [showAppleGuide, setShowAppleGuide] = useState(false);
  const [showAndroidGuide, setShowAndroidGuide] = useState(false);

  const handleChooseDevice = (device: 'apple' | 'android') => {
    if (device === 'apple') {
      setShowAppleGuide(true);
    }

    if (device === 'android') {
      setShowAndroidGuide(true);
    }
  };
  const handleCloseChooseDevice = () => {
    setTimeout(() => {
      setChooseDevice(false);
    }, 300);
  };

  const handleCloseAppleGuide = () => {
    setTimeout(() => {
      setShowAppleGuide(false);
    }, 300);
  };

  const handleCloseAndroidGuide = () => {
    setTimeout(() => {
      setShowAndroidGuide(false);
    }, 300);
  };

  return (
    <>
      <PageWrapper rootClassName={clsx('w-full', className)}>
        <InstallationGuideImage
          className='w-full h-auto max-w-full cursor-pointer bg-wl-primary rounded-xl'
          onClick={() => setChooseDevice(true)}
        />
      </PageWrapper>

      <ResponsiveModal
        isOpen={chooseDevice}
        title='How To Install eSIM?'
        headerIcon={<Simcard1 variant='Bulk' />}
        content={<ChooseDevice onChooseDevice={handleChooseDevice} />}
        onClose={handleCloseChooseDevice}
      />

      <ResponsiveModal
        isOpen={showAppleGuide}
        title='How To Install eSIM?'
        headerIcon={<Simcard1 variant='Bulk' />}
        content={<AppleGuide onClose={handleCloseAppleGuide} />}
        onClose={handleCloseAppleGuide}
      />

      <ResponsiveModal
        isOpen={showAndroidGuide}
        title='How To Install eSIM?'
        headerIcon={<Simcard1 variant='Bulk' />}
        content={<AndroidGuide onClose={handleCloseAndroidGuide} />}
        onClose={() => setShowAndroidGuide(false)}
      />
    </>
  );
}
